import { ref } from 'vue';
import { useI18n } from 'vue-i18n';
import { i18n } from '@/plugins/i18n';

export const DEFAULT_LANGUAGES: Array<string> = ['es', 'en'];
export const DEFAULT_LANGUAGE = 'en';
export const ROLES = {
  ADMIN: 'admin',
  AGENT: 'agent',
  OWNER: 'owner',
  TENANT: 'tenant',
};

// Functions to get GENDERS and DOCUMENTS
export function useGenders() {
  const { t } = useI18n();
  return ref<{ id: string; label: string }[]>([
    { id: 'male', label: t('profile.labels.male') },
    { id: 'female', label: t('profile.labels.female') },
    { id: 'other', label: t('profile.labels.other') },
  ]);
}

export function useDocuments() {
  const { t } = useI18n();
  return ref<{ id: string; label: string }[]>([
    { id: 'id', label: t('profile.labels.documentId') },
    { id: 'passport', label: t('profile.labels.passport') },
    { id: 'tax_id', label: t('profile.labels.taxId') },
  ]);
}

export function useLanguages() {
  const { t } = useI18n();
  return ref<{ id: string; label: string }[]>([
    { id: 'en', label: t('language.en') },
    { id: 'es', label: t('language.es') },
  ]);
}

export const cancelReasonsOptions = () => {
  return {
    1: i18n.global.t('cancelledReasonsItems.temp'),
    2: i18n.global.t('cancelledReasonsItems.prev'),
    3: i18n.global.t('cancelledReasonsItems.ten'),
    4: i18n.global.t('cancelledReasonsItems.rate'),
    5: i18n.global.t('cancelledReasonsItems.stay'),
    6: i18n.global.t('cancelledReasonsItems.acco'),
    7: i18n.global.t('cancelledReasonsItems.dep'),
    8: i18n.global.t('cancelledReasonsItems.meet'),
    9: i18n.global.t('cancelledReasonsItems.unna'),
    10: i18n.global.t('cancelledReasonsItems.canc'),
    11: i18n.global.t('cancelledReasonsItems.owner'),
    12: i18n.global.t('cancelledReasonsItems.book'),
    13: i18n.global.t('cancelledReasonsItems.error'),
    14: i18n.global.t('cancelledReasonsItems.prop'),
  };
};

export const SIGNATURE_TYPES = {
  MANUAL: 'manual',
  DIGITAL: 'digital',
};

export const DOCUMENT_TYPES = {
  GLOBAL: 'global',
  CONTRACT: 'contract',
};

export const DOCUMENT_VERIFICATION_STATUSES = {
  PENDING: 'pending',
  SIGNED_BY_OWNER: 'signed_by_owner',
  SIGNED_BY_TENANT_AND_OWNER: 'signed_by_tenant_and_owner',
  PENDING_ACCEPTANCE_OR_REVIEW: 'pending_acceptance_or_review',
  REJECTED: 'rejected',
  NOT_VALIDATED: 'not_validated',
  VALIDATED: 'validated',
};

